// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Markhor Systems - Base Styles */

/* Modern CSS Reset */
*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html {
  scroll-behavior: smooth;
  font-size: 16px;
}

body {
  margin: 0;
  font-family: 'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  line-height: 1.6;
  color: #e2e8f0;
  background: #100D25;
  min-height: 100vh;
  overflow-x: hidden;
}

/* Improved Text Rendering */
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  line-height: 1.2;
  letter-spacing: -0.02em;
}

p {
  line-height: 1.7;
  color: #94a3b8;
}

/* Links */
a {
  color: inherit;
  text-decoration: none;
  transition: color 0.3s ease;
}

/* Buttons */
button {
  font-family: inherit;
  cursor: pointer;
  border: none;
  background: none;
}

/* Lists */
ul,
ol {
  list-style: none;
}

/* Images */
img {
  max-width: 100%;
  height: auto;
  display: block;
}

/* Code */
code {
  font-family: 'JetBrains Mono', 'Fira Code', 'Monaco', 'Consolas', monospace;
  background: rgba(255, 255, 255, 0.1);
  padding: 0.125rem 0.375rem;
  border-radius: 0.25rem;
  font-size: 0.875em;
  color: #ffffff;
}

/* Selection */
::selection {
  background: #FFFFFF;
  color: #100D25;
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #16122f;
}

::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.4);
  border-radius: 9999px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.6);
}

/* Smooth Scrolling for Anchor Links */
html:focus-within {
  scroll-behavior: smooth;
}

/* Reduce Motion for Accessibility */
@media (prefers-reduced-motion: reduce) {

  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }

  html:focus-within {
    scroll-behavior: auto;
  }
}

/* Focus Visible */
:focus-visible {
  outline: 2px solid #FFFFFF;
  outline-offset: 2px;
}

/* Form Elements Reset */
input,
textarea,
select {
  font-family: inherit;
  font-size: inherit;
}

/* Table Reset */
table {
  border-collapse: collapse;
  width: 100%;
}

/* Print Styles */
@media print {
  body {
    background: white;
    color: black;
  }

  @page {
    margin: 2cm;
  }
}

/* Animations */
@keyframes marquee {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(calc(-50% - 1rem));
  }
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }

  100% {
    background-position: 200% 0;
  }
}

@keyframes float {

  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-10px);
  }
}

@keyframes pulse-soft {

  0%,
  100% {
    transform: scale(1);
    opacity: 1;
  }

  50% {
    transform: scale(1.05);
    opacity: 0.8;
  }
}

/* Utility Classes */
.animate-marquee {
  animation: marquee 40s linear infinite;
  display: flex;
  gap: 6rem;
  /* Match the gap in js */
}

.animate-marquee:hover {
  animation-play-state: paused;
}

.animate-shimmer {
  background: linear-gradient(90deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.4) 50%,
      rgba(255, 255, 255, 0) 100%);
  background-size: 200% 100%;
  animation: shimmer 3s infinite;
}

.hover-lift {
  transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.hover-lift:hover {
  transform: translateY(-8px);
}

.hover-glow {
  transition: all 0.3s ease;
}

.hover-glow:hover {
  box-shadow: 0 0 30px rgba(255, 255, 255, 0.2);
}

/* Card Glow Effect */
.card-glow::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: inherit;
  padding: 2px;
  background: linear-gradient(45deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  mask-composite: exclude;
  opacity: 0.5;
  transition: opacity 0.3s ease;
}

.card-glow:hover::before {
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,kCAAkC;;AAElC,qBAAqB;AACrB;;;EAGE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT;kFACgF;EAChF,mCAAmC;EACnC,kCAAkC;EAClC,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,4BAA4B;AAC5B;;;;;;EAME,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,cAAc;EACd,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA,YAAY;AACZ;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA,UAAU;AACV;;EAEE,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,2EAA2E;EAC3E,oCAAoC;EACpC,0BAA0B;EAC1B,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,sCAAsC;AACtC;EACE,uBAAuB;AACzB;;AAEA,oCAAoC;AACpC;;EAEE;;;IAGE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;EACxC;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA,kBAAkB;AAClB;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;;;EAGE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE;IACE,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,eAAe;AACf;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;;EAEE;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;;EAEE;;IAEE,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;AACF;;AAEA,oBAAoB;AACpB;EACE,sCAAsC;EACtC,aAAa;EACb,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE;;;kCAGgC;EAChC,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;AAC/C;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,YAAY;EACZ,sFAAsF;EAEtF,sEAAsE;EAEtE,uBAAuB;EACvB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ","sourcesContent":["/* Markhor Systems - Base Styles */\n\n/* Modern CSS Reset */\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nhtml {\n  scroll-behavior: smooth;\n  font-size: 16px;\n}\n\nbody {\n  margin: 0;\n  font-family: 'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  line-height: 1.6;\n  color: #e2e8f0;\n  background: #100D25;\n  min-height: 100vh;\n  overflow-x: hidden;\n}\n\n/* Improved Text Rendering */\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: 'Montserrat', sans-serif;\n  font-weight: 600;\n  line-height: 1.2;\n  letter-spacing: -0.02em;\n}\n\np {\n  line-height: 1.7;\n  color: #94a3b8;\n}\n\n/* Links */\na {\n  color: inherit;\n  text-decoration: none;\n  transition: color 0.3s ease;\n}\n\n/* Buttons */\nbutton {\n  font-family: inherit;\n  cursor: pointer;\n  border: none;\n  background: none;\n}\n\n/* Lists */\nul,\nol {\n  list-style: none;\n}\n\n/* Images */\nimg {\n  max-width: 100%;\n  height: auto;\n  display: block;\n}\n\n/* Code */\ncode {\n  font-family: 'JetBrains Mono', 'Fira Code', 'Monaco', 'Consolas', monospace;\n  background: rgba(255, 255, 255, 0.1);\n  padding: 0.125rem 0.375rem;\n  border-radius: 0.25rem;\n  font-size: 0.875em;\n  color: #ffffff;\n}\n\n/* Selection */\n::selection {\n  background: #FFFFFF;\n  color: #100D25;\n}\n\n/* Scrollbar */\n::-webkit-scrollbar {\n  width: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: #16122f;\n}\n\n::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.4);\n  border-radius: 9999px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.6);\n}\n\n/* Smooth Scrolling for Anchor Links */\nhtml:focus-within {\n  scroll-behavior: smooth;\n}\n\n/* Reduce Motion for Accessibility */\n@media (prefers-reduced-motion: reduce) {\n\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n  }\n\n  html:focus-within {\n    scroll-behavior: auto;\n  }\n}\n\n/* Focus Visible */\n:focus-visible {\n  outline: 2px solid #FFFFFF;\n  outline-offset: 2px;\n}\n\n/* Form Elements Reset */\ninput,\ntextarea,\nselect {\n  font-family: inherit;\n  font-size: inherit;\n}\n\n/* Table Reset */\ntable {\n  border-collapse: collapse;\n  width: 100%;\n}\n\n/* Print Styles */\n@media print {\n  body {\n    background: white;\n    color: black;\n  }\n\n  @page {\n    margin: 2cm;\n  }\n}\n\n/* Animations */\n@keyframes marquee {\n  0% {\n    transform: translateX(0);\n  }\n\n  100% {\n    transform: translateX(calc(-50% - 1rem));\n  }\n}\n\n@keyframes shimmer {\n  0% {\n    background-position: -200% 0;\n  }\n\n  100% {\n    background-position: 200% 0;\n  }\n}\n\n@keyframes float {\n\n  0%,\n  100% {\n    transform: translateY(0);\n  }\n\n  50% {\n    transform: translateY(-10px);\n  }\n}\n\n@keyframes pulse-soft {\n\n  0%,\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n\n  50% {\n    transform: scale(1.05);\n    opacity: 0.8;\n  }\n}\n\n/* Utility Classes */\n.animate-marquee {\n  animation: marquee 40s linear infinite;\n  display: flex;\n  gap: 6rem;\n  /* Match the gap in js */\n}\n\n.animate-marquee:hover {\n  animation-play-state: paused;\n}\n\n.animate-shimmer {\n  background: linear-gradient(90deg,\n      rgba(255, 255, 255, 0) 0%,\n      rgba(255, 255, 255, 0.4) 50%,\n      rgba(255, 255, 255, 0) 100%);\n  background-size: 200% 100%;\n  animation: shimmer 3s infinite;\n}\n\n.hover-lift {\n  transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n.hover-lift:hover {\n  transform: translateY(-8px);\n}\n\n.hover-glow {\n  transition: all 0.3s ease;\n}\n\n.hover-glow:hover {\n  box-shadow: 0 0 30px rgba(255, 255, 255, 0.2);\n}\n\n/* Card Glow Effect */\n.card-glow::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border-radius: inherit;\n  padding: 2px;\n  background: linear-gradient(45deg, transparent, rgba(255, 255, 255, 0.2), transparent);\n  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);\n  mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);\n  -webkit-mask-composite: xor;\n  mask-composite: exclude;\n  opacity: 0.5;\n  transition: opacity 0.3s ease;\n}\n\n.card-glow:hover::before {\n  opacity: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
